module.exports = __webpack_public_path__ + "static/media/visa.ee305d5d.png";